import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function BBB(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#005A78" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M9.73207 7.85755C9.73199 7.25978 9.90806 6.6774 10.2349 6.19434L11.7119 4L11.9331 4.17313C11.8063 4.36177 11.7545 4.59697 11.7889 4.82685C11.8234 5.05673 11.9413 5.26241 12.1167 5.39853L14.9115 7.587C16.0903 8.50874 16.3525 10.2854 15.4971 11.5555L13.6731 14.271L13.4498 14.0949C13.6717 13.7688 13.7635 13.3608 13.7049 12.9614C13.6463 12.5621 13.4421 12.2045 13.1376 11.968L10.8228 10.1622C10.2551 9.72139 9.87446 9.05461 9.76531 8.31003C9.74335 8.16036 9.73224 8.00908 9.73207 7.85755ZM8.89693 11.8824C8.35319 12.7196 8.52011 13.8901 9.26984 14.4975L10.9685 15.8752C11.0589 15.9481 11.1196 16.0582 11.1371 16.1811C11.1547 16.304 11.1276 16.4297 11.062 16.5303L11.3178 16.7368L12.2154 15.3524C12.4231 15.0349 12.5353 14.6522 12.5361 14.2591C12.5361 14.1592 12.5291 14.0594 12.515 13.9607C12.4451 13.4691 12.2016 13.0292 11.839 12.7395L10.1403 11.3619C10.05 11.289 9.98942 11.179 9.97194 11.0561C9.96862 11.0313 9.96678 11.0061 9.96641 10.981C9.9664 10.8826 9.99438 10.7867 10.0463 10.7072L9.79302 10.5008L8.89693 11.8824ZM15.3306 17.0018H8.25691L8 17.9266H9.88499L10.2451 19.2027H13.344L13.7026 17.9266H15.5876L15.3306 17.0018Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

BBB.propTypes = propTypes;
BBB.defaultProps = defaultProps;

export default BBB;
